import { TraditionalTrail } from "@/models/trail.model";
import { ITrailEvent, TraditionalRest } from "@/services/rest/traditional.rest";
import { defineStore } from "pinia";
import { instance } from "..";
import { useChapterStore } from "./chapter";
import { ELoader, useLoaderStore } from "./loader";
import { useMaterialStore } from "./material";

export const store = defineStore({
  id: "trail",
  state: () => ({
    trails: [] as TraditionalTrail[],
    ableToQuiz: null as boolean | null,
    currentTrail: null as TraditionalTrail | null,
  }),
  getters: {
    getLastTrail: (state) => state.trails[state.trails.length - 1],
    currentTrailIndex: (state) => {
      return state.trails?.findIndex(
        (trail) => trail.id === state.currentTrail?.id
      );
    },
    isLastTrail(state): boolean {
      return this.currentTrailIndex === state.trails.length - 1;
    },
  },
  actions: {
    async getTrailsByChapterId(chapterId, loadInit?: boolean) {
      const courseId = JSON.parse(String(localStorage.getItem("courseID")));
      const classroomId = localStorage.getItem("classId") ?? undefined;

      await TraditionalRest.getTrailsByChapterId(courseId, chapterId, {
        classroomId: classroomId,
      })
        .then((response) => {
          this.trails = response.linearTrails;
          setTimeout(() => (this.ableToQuiz = response.ableToQuiz), 250);
          this.loadTrailOnInit(loadInit);
        })
        .catch(() => {
          this.trails = [];
          this.ableToQuiz = null;
        })
        .finally(() => useLoaderStore.stop(ELoader.TRAILS));
    },

    loadTrailOnInit(loadInit) {
      if (loadInit) {
        const lastIndex = Math.max(
          useTrailStore.trails.findIndex((e) => !e.done),
          0
        );
        useTrailStore.selectTrail(lastIndex);
      }
    },

    selectTrail(index: number) {
      if (!this.trails[index]) return;
      const trail = this.trails[index];
      this.currentTrail = trail;
      useLoaderStore.start(ELoader.MATERIALS);
      useMaterialStore.getMaterialsByTrailId(trail.id);
    },

    setTrailDoneById(trailId: string) {
      const trail = this.trails.find((trail) => trail.id === trailId);
      if (trail) trail.done = true;
    },

    trailNext() {
      const advance = useMaterialStore.AllMaterialsDone && !this.isLastTrail;
      if (advance) this.selectTrail(this.currentTrailIndex + 1);
      return advance;
    },

    trailPrev() {
      const goBack = this.currentTrailIndex > 0;
      if (goBack) this.selectTrail(this.currentTrailIndex - 1);
      return goBack;
    },

    async trailEvent() {
      const courseId = JSON.parse(String(localStorage.getItem("courseID")));
      const classroomId = localStorage.getItem("classId") ?? undefined;
      const currentTrail = this.trails[this.currentTrailIndex];

      if (
        currentTrail &&
        !currentTrail.done &&
        useMaterialStore.AllMaterialsDone
      ) {
        const data: ITrailEvent = {
          learningObjectiveId: currentTrail?.id!,
          clientTime: new Date(),
        };

        await TraditionalRest.trailEvent(courseId, data, {
          classroomId,
        }).then(() => {
          this.setTrailDoneById(currentTrail?.id!);
          useChapterStore.getCoursePercentage();
          useLoaderStore.stop(ELoader.TRAILS);
        });
      }
    },
  },
});

export const useTrailStore = store(instance);
